
import React from 'react';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';

import {
    PanelSectionTitle,
    utils
} from '../../core';

import ItemDot from './ItemDot';

const ExternalMapLink = ({coordinates, externalMapLink}) => {

    const classNames = mergeStyleSets({
        ExternalMapLink: {
        },
        image: {
        }
    });

    const handleClick = () => {
        let x = Math.round(coordinates[0]);
        let y = Math.round(coordinates[1]);

        if (externalMapLink.useWgs) {
            const wgs = utils.toWgs84(coordinates);
            x = wgs[0];
            y = wgs[1];
        }

        let url = externalMapLink.url;
        url = url.replace('@X@', x);
        url = url.replace('@Y@', y);

        window.open(url, externalMapLink.id);
    }

    return (
        <Stack horizontal  className={classNames.ExternalMapLink} tokens={{childrenGap: 4}}>
            <Stack.Item align="center">
                <ItemDot />
            </Stack.Item>
            <Stack.Item align="center">
                <img className={classNames.image} src={externalMapLink.icon} />
            </Stack.Item>
            <Stack.Item align="center">
                <Link onClick={handleClick}>{externalMapLink.title}</Link>
            </Stack.Item>
        </Stack>
    );
}

const ExternalMapLinks = ({coordinates, externalMapLinks}) => {

    const classNames = mergeStyleSets({
        ExternalMapLinks: {
            paddingTop: 8
        },
    });

    return (
        <Stack className={classNames.ExternalMapLinks} tokens={{childrenGap: 4}}>
            <PanelSectionTitle title="Další možnosti práce se zadaným umístěním" />
            <Stack horizontal tokens={{childrenGap: 8}}>
                <Stack.Item>Souřadnice:</Stack.Item>
                <Stack.Item>{Math.round(coordinates[0])}, {Math.round(coordinates[1])}</Stack.Item>
            </Stack>
            {externalMapLinks.map(item => {
                return (
                    <ExternalMapLink
                        key={item.id}
                        coordinates={coordinates}
                        externalMapLink={item}
                    />
                );
            })}
        </Stack>
    );
}

export default ExternalMapLinks;
